import React from 'react'
import type { HealthStatus } from '@/types/status'

interface StatusDotProps {
  status: HealthStatus
  pulse?: boolean
  size?: 'sm' | 'md' | 'lg'
}

const colorMap: Record<HealthStatus, string> = {
  healthy: 'bg-success',
  warning: 'bg-warning',
  error: 'bg-error',
  unknown: 'bg-text-dim',
}

const sizeMap = {
  sm: 'w-1.5 h-1.5',
  md: 'w-2 h-2',
  lg: 'w-2.5 h-2.5',
}

export function StatusDot({ status, pulse = false, size = 'md' }: StatusDotProps) {
  const color = colorMap[status]
  const sz = sizeMap[size]

  return (
    <span className="relative inline-flex items-center justify-center">
      {pulse && status === 'healthy' && (
        <span
          className={`absolute inline-flex rounded-full ${color} opacity-75 animate-ping ${sz}`}
        />
      )}
      <span
        className={`relative inline-flex rounded-full ${color} ${sz}`}
        aria-label={status}
        role="img"
      />
    </span>
  )
}
